import React, { useState, useEffect } from 'react'
import { useDispatch } from 'react-redux'

import { Message, Panel, Row } from 'rsuite'
import scrollToComponent from 'react-scroll-to-component'
import { useForm, Controller } from 'react-hook-form'
import ButtonPanel from '../../ButtonPanel'
import OverlayLoader from '../../../components/OverlayLoader/OverlayLoader'
import EditFormListWidget from '../dynamicForm/EditFormListWidget'
import ViewFormListWidget from '../dynamicForm/ViewFormListWidget'
import SettingEditFormListWidget from '../dynamicForm/SettingEditFormListWidget'
import HTMLWidget from '../../HTMLWidget'
import CustomAlertMessageInfo from '../../CustomAlertMessageInfo'
import { SUB_PROJECT_ID } from '../../../constants/constants'
import { sessionGetItemStr } from '../../../utils/sessionHelpers'
import { setAlertMessage } from '../../../utils/messageUtil'
import { saveFormTargetGroup } from '../../../redux/actions/subProjectProposal'
import { createDynamicListReq, setValueDynamicToReq } from '../../../utils/dynamicListReq'
import { doneLoading, startLoading } from '../../../utils/loading'
import { DEFAULT_ERR_MSG, SAVE_SUCCESS_MSG } from '../../../constants/msgText'

export default function ProjectTagetWidget(props) {
  const { showCommandButton, isEdit, onChangeIsEdit } = props

  const { register, handleSubmit, errors, control, setValue, clearErrors } = useForm()

  const [section, setSection] = useState()
  const [isError, setIsError] = useState(false)
  const [isLoading, setIsLoading] = useState(false)
  const [notiMsg, setNotiMsg] = useState()
  const [formSchema, setFormSchema] = useState(props.schema)

  const mode = location.search.substring(1)
  const subProjectId = sessionGetItemStr(SUB_PROJECT_ID)

  const handleSave = async (request) => {
    setIsLoading(true)
    startLoading()
    try {
      let response = await saveFormTargetGroup(subProjectId, request)
      if (response) {
        setFormSchema(response)
        setAlertMessage('success', SAVE_SUCCESS_MSG, setNotiMsg)
      } else {
        setAlertMessage('error', DEFAULT_ERR_MSG, setNotiMsg)
      }
    } catch (e) {
      console.log('error', e)
      setAlertMessage('error', e?.response?.data?.errors?.message || DEFAULT_ERR_MSG, setNotiMsg)
    }
    doneLoading()
    setIsLoading(false)
  }

  const onSubmit = (data) => {
    console.log('data', data)
    // console.log('dd : ', formSchema?.objects)

    let values = createDynamicListReq(data.newObjects, data.newObjectsValuesName)

    let templateValues = setValueDynamicToReq(formSchema?.objects, data)
    /*
    formSchema?.objects?.forEach((e) => {
      templateValues.push({ refId: e.id, result: data[`${e.id}`] || null })
    })
      */

    let request = {
      //id: formSchema.id,
      templateValues: templateValues,
      values: values,
    }

    // console.log('request : ', JSON.stringify(request))

    handleSave(request)
  }

  return (
    <Panel
      shaded
      header={formSchema.header}
      collapsible
      defaultExpanded
      ref={(section) => {
        setSection(section)
      }}
      style={{ marginBottom: 20 }}
    >
      {isLoading && <OverlayLoader />}

      {isEdit && showCommandButton ? (
        <>
          {/* {formSchema.description && (
            <Row style={{ marginBottom: 10 }}>
              <CustomAlertMessageInfo contents={formSchema.description} />
            </Row>
          )} */}

          <EditFormListWidget
            schema={formSchema}
            register={register}
            Controller={Controller}
            control={control}
            errors={errors}
            setValue={setValue}
            clearErrors={clearErrors}
            setLoading={setIsLoading}
          />
          <div style={{ marginTop: -20 }}>
            <SettingEditFormListWidget
              inputMode
              hideDescription
              hideResultType
              fixedResultType={1}
              schema={formSchema}
              register={register}
              Controller={Controller}
              control={control}
              errors={errors}
              setValue={setValue}
              clearErrors={clearErrors}
              setLoading={setIsLoading}
              datas={formSchema.newObjects || []}
            />
          </div>
        </>
      ) : (
        <ViewFormListWidget
          objects={[...(formSchema.objects || []), ...(formSchema.newObjects || [])]}
          fixedResultType={1}
        />
      )}

      {formSchema.note && (
        <Message
          showIcon
          type="info"
          style={{ marginTop: 20 }}
          description={<HTMLWidget data={formSchema.note} />}
        />
      )}

      {showCommandButton && !mode && (
        <div className="right">
          <hr />
          {notiMsg && (
            <Message
              closable
              showIcon
              type={notiMsg.type}
              description={notiMsg.msg}
              onClose={() => setNotiMsg('')}
              style={{ marginBottom: 10 }}
              className="left"
            />
          )}

          <ButtonPanel
            isDisabled={isLoading}
            isEdit={isEdit}
            isError={isError}
            buttonText={formSchema.buttonText || formSchema.header}
            onSave={handleSubmit(onSubmit)}
            onCancel={() => {
              setIsError(false)
              onChangeIsEdit(!isEdit)
            }}
            onEdit={() => {
              setIsError(false)
              onChangeIsEdit(!isEdit)
              scrollToComponent(section, { offset: 0, align: 'top', duration: 500 })
            }}
          />
        </div>
      )}
    </Panel>
  )
}
